module.exports = __webpack_public_path__ + "img/6.926f6dd5.png";